import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, LOCALE_ID, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, map, Observable, of, startWith, Subscription, switchMap, tap } from 'rxjs';
import { BaseComponent } from '../../base/base-component.directive';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';



export function streetWithHouseNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const street = control.get('street')?.value;
    const houseNumber = control.get('house_number')?.value;

    // If street is empty, house_number should also be empty
    if (street == null || street.trim() === '') {
      if (houseNumber != null && houseNumber.trim() !== '') {
        return { streetWithHouseNumberError: 'Il civico non può essere inserito se la via è vuota' };
      }
    }

    return null;  // No errors
  };
}


export const MY_DATE_FORMATS = {

  parse: {

    dateInput: 'DD/MM/YYYY',

  },

  display: {

    dateInput: 'DD/MM/YYYY',

    monthYearLabel: 'MMMM YYYY',

    dateA11yLabel: 'LL',

    monthYearA11yLabel: 'MMMM YYYY'

  },

};
@Component({
  selector: 'app-grid-filters',
  standalone: false,
  templateUrl: './grid-filters.component.html',
  styleUrls: ['./grid-filters.component.scss'],
  providers:[
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }]
})
export class GridFiltersComponent extends BaseComponent implements OnInit {
  filterFormGroup: FormGroup = this.formBuilder.group({
    field: [null, [Validators.required]],
    value: [null, [Validators.required]],
    type:[null]
  });

  range: FormGroup= this.formBuilder.group({
    field: [null, [Validators.required]],
    start: [null, [Validators.required]],
    end: [null, [Validators.required]],
  });

  addressFormGroup: FormGroup = this.formBuilder.group({
    field: [null, [Validators.required]],
    city: [null, [Validators.required]],
    street: [null],
    house_number: [null],
  },
  { validators: streetWithHouseNumberValidator() });

  filteredOptions?: Observable<FilterFieldOption[]>=of([]);

  layoutDirection: 'row' | 'column' = 'column';
  options?: FilterFieldOption[];
  value: any;
  values:any[]=[]
  values_id:any[]=[]
  start?: string;
  end?: string;
  separatorKeysCodes: number[] = [ENTER, COMMA]
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  selectedValue= 0;
  type?:string[]

  rawData: Array<any> = [];
  selectData: Array<any> = []

  @ViewChild('valueInput') valueInput?: ElementRef;
  get selectedField(): FilterField {
    return this.filterFormGroup.value?.field;
  }

  get FieldType(): typeof FieldType {
    return FieldType;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GridFilterParam,
    private dialogRef: MatDialogRef<GridFiltersComponent>,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  get_subcategory(value:number){
    if (this.options !== undefined) {
      if(this.options[0].json && this.filterFormGroup.value && typeof(value)==='number'){
        return this.options?.filter((option) =>
          option?.id === value
        )[0].json;
      }
    }
    return []
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.values.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  remove(option: FilterFieldOption): void {
    const index = this.values.indexOf(option);
    if (index >= 0) {
      this.values.splice(index, 1);
    }
  }
  
  selected(event: MatAutocompleteSelectedEvent): void {
    this.values.push(event.option.viewValue);
    if (this.valueInput) {
      this.valueInput.nativeElement.value = '';
    }
  }

  selected_id(event: MatAutocompleteSelectedEvent): void {
    this.values_id.push(event.option.value);
    this.values.push(event.option.viewValue);
    if (this.valueInput) {
      this.valueInput.nativeElement.value = '';
    }
  }


  setLayout(){
    if(window.innerWidth > 2000){
      this.layoutDirection = 'row'; 
    } else {
      this.layoutDirection = 'column';
    }
  }
  
  
  
  ngOnInit(): void {
    this.setLayout();

    /*this.filteredOptions = this.filterFormGroup.get('value')!.valueChanges.pipe(
      startWith(''),
      map((val: string | FilterFieldOption) => this._filterOptions(val))
    );*/
    /*this.filteredOptions = this.filterFormGroup.get('value')!.valueChanges.pipe(
      startWith(''),
      switchMap((val: string | FilterFieldOption) =>
        this._filterOptions(val)
      )
    );*/
    this.filteredOptions = this.filterFormGroup.get('value')!.valueChanges.pipe(
      startWith(''),
      switchMap((val: string | FilterFieldOption) =>
        this._filterOptions(val)
      ),
      tap(options => {
        const currentValue = this.filterFormGroup.get('value')!.value;

        if (
          options.length === 1 &&
          options[0].description.toLowerCase()===String(currentValue).toLowerCase()
        ) {
          this.filterFormGroup.get('value')!.setValue(options[0].id, {
            emitEvent: false
          });
        }
      })
    );

    this.addressFormGroup
      .get('field')!
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));
    
    this.range
      .get('field')!
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));

    this.filterFormGroup
      .get('field')!
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));

  }

  setAddress(){
    if(this.addressFormGroup.value.street !== null && this.addressFormGroup.value.house_number !== null){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.street + "," + this.addressFormGroup.value.house_number
      return val
    }
    if(this.addressFormGroup.value.street !== null && this.addressFormGroup.value.house_number === null ){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.street 
      return val
    }
    if(this.addressFormGroup.value.street === null && this.addressFormGroup.value.house_number !== null){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.house_number
      return val
    }
    else{
      const val = this.addressFormGroup.value.city;
      return val
    }
  }

  
  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: Event): void {
    const e = event as KeyboardEvent;

    if (e.key !== 'Enter') return;

    this.addFilter();
  }

  addFilter() {
    var chips: string[] = [];
    this.addressFormGroup.markAllAsTouched();
    this.range.markAllAsTouched();
    this.filterFormGroup.markAllAsTouched();
    if (this.values.length !==0){
      this.filterFormGroup.value.value=this.values;
    }
    if(this.values_id.length !==0){
      this.filterFormGroup.value.value=this.values_id;
      chips=this.values
    }
    if(this.filterFormGroup.value.value !== null ) {
      if (this.filterFormGroup.valid) {
  
        const { field, value, type } = this.filterFormGroup.value;
        if (chips.length !==0){
          this.dialogRef.close({ [field.name]: value, chips});
        }
        if (type != null){
          this.dialogRef.close({ [field.name]: value, type});
        } else {
          this.dialogRef.close({ [field.name]: value});
        }
      }
    }
    if(this.range.value.start !== null && this.range.value.end !== null && this.filterFormGroup.value.field.type === 5){
      const start=moment(this.range.value.start._d).format('yyyy-MM-DD');
      const end=moment(this.range.value.end._d).format('yyyy-MM-DD');
      this.range.value.field=this.filterFormGroup.value.field;
      const { field, value=`${start},${end}` } = this.range.value;
      this.dialogRef.close({ [field.name]: value });
    }
    if(this.range.value.start !== null && this.range.value.end !== null && this.filterFormGroup.value.field.type === 9){
      const start=this.range.value.start._d.valueOf();
      const end=this.range.value.end._d.valueOf();
      this.range.value.field=this.filterFormGroup.value.field;
      const { field, value=`${start},${end}` } = this.range.value;
      this.dialogRef.close({ [field.name]: value });
    }
    if(!this.addressFormGroup.hasError('streetWithHouseNumberError') && this.addressFormGroup.value.city !== null){
      this.addressFormGroup.value.field=this.filterFormGroup.value.field;
      const field=this.filterFormGroup.value.field;
      const val = this.setAddress();
      this.dialogRef.close({ [field.name]: val });
    }
  }


  /*private _filterOptions1(
    value: string | FilterFieldOption
  ): FilterFieldOption[] | undefined {
    if (typeof value === 'string') {
      const search = value.toUpperCase();
      return this.options?.filter((option) =>
        option?.description ? option?.description.toUpperCase().includes(search) : null // DA verificare 
      );
    }
    return [];
  }*/

  private _filterOptions(
    value: string | FilterFieldOption
  ): Observable<FilterFieldOption[]> {

    if (typeof value !== 'string') {
      return of([]);
    }

    const search = value.toUpperCase();

    const localResults =
      this.options?.filter(option =>
        option.description?.toUpperCase().includes(search)
      ) ?? [];

    if (localResults.length > 0) {
      return of(localResults);
    }

    const field = this.filterFormGroup.value.field as FilterField;

    if (!field?.searchFn) {
      return of([]);
    }

    return field.searchFn(search).pipe(
      tap(results => {
        this.options = results ?? [];
      })
    );
  }

  check_if_json(){
    var res:boolean;
    if(this.options !== undefined){
      this.options.some(array=>{
        res=array.hasOwnProperty("json")
      })
    } else {
      res = false;
    }
    return res!
  }

  displayFn = (groupId: string | number): string => {
    return (
      this.options?.find((item) => item.description === groupId)?.description ||
      this.options?.find((item) => item.id === groupId)?.description ||
      ''
    );
  };

  displayFn2() {
    return (groupId: string | number) =>
      this.options?.find((item) => item.description === groupId)?.description || this.options?.find((item) => item.id === groupId)?.description; 
  }
}

export type GridFilterParam = {
  fields: FilterField[];
};

export type FilterField = {
  name: string;
  text: string;
  type: FieldType;
  options?: Observable<FilterFieldOption[]>;
  searchFn?: (term: string) => Observable<FilterFieldOption[]>;
};

export enum FieldType {
  TEXT,//this.filterFormGroup.value.field.type===0
  AUTOCOMPLETE,//this.filterFormGroup.value.field.type===1
  DATETIME,//this.filterFormGroup.value.field.type===2
  UPPERCASE,//this.filterFormGroup.value.field.type===3
  UPPERCASE_ARRAY,//this.filterFormGroup.value.field.type===4
  DATERANGE,//this.filterFormGroup.value.field.type===5
  STATUS,//this.filterFormGroup.value.field.type===6
  LOwERCASE_ARRAY,//this.filterFormGroup.value.field.type===7
  BOOLEAN,//this.filterFormGroup.value.field.type===8
  GRAFANA_DATERANGE,//this.filterFormGroup.value.field.type===9
  GRAFANA_AUTOCOMPLETE,
  CONTRACT_TYPE,
  VEHICLE_STATUS,
  DOCTYPE,
  CLIENT_SIDE_BOOLEAN,
  AUTOCOMPLETE_DATE,
  AUTOCOMPLETE_UPPER,
  WASTE_TYPE,
  LOCATION,
  WHITELIST_TYPE,
  WLTAG_LIST_MODE,
  ADDRESS,
  SMARTBIN_STATE,
  WAYPOINT_STATUS,
  AUTOCOMPLETE_ARRAY,
  READING_STATUS,
  NUMBER,
  VEHICLE_CONNECTION_STATUS,
  AUTOCOMPLETE_DESCRIPTION,
  ROLL_ON_READING_STATUS,
  DEVICE_STATUS_NOTES
}

export type FilterFieldOption = { id: number; description: string, json?:NestedJson[]  };
export type NestedJson ={ cod:string; tipologia: string;}
export type Address = { city: string; street: string; house_number: string; }